var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "virtual-tree",
    _vm._b(
      {
        attrs: {
          data: _vm.originTree,
          checked: _vm.checked,
          clearable: _vm.clearable,
          props: _vm.customProps,
          showDelete: _vm.filterDelete,
          placeholder: _vm.$attrs.placeholder || "请选择组织机构",
          multiple: _vm.multiple
        },
        on: { change: _vm.checkedChange }
      },
      "virtual-tree",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-408d6bea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-408d6bea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectTree.vue
// module id = null
// module chunks = 